import Selector from 'awesome-selector';

const yesNoOptions = [
    {
        name: 'Yes',
        id: 'yes',
    },
    {
        name: 'No',
        id: 'no',
    },
];

export const YesNoSelector = (question, callback) => {
    new Selector({
        title: question,
        options: yesNoOptions,
        onSelect: (id, name) => {
            callback(id);
        },
        currentOptionId: 'no',
        theme: 'dark',
        style: {
            container: [['background-color', 'rgba(0, 0, 0, .25)']],
        },
    });
};
